import React, { useEffect, useState } from "react";
import { SvgArrow } from "../svg";
import { Link } from "react-router-dom";
import { getAddress } from "../../utils";

export const CustomerDetailsCard = ({ customer }) => {
    return(
        <Link to={`/customers/${customer.id}`}>
        <div className="card">
            <div className="row">
                <div className="col-md-5 col-12">
                    <div className="p-lg-4 px-4 py-2">
                        <label>{gettext("Name")}</label>
                        <p>{customer.name}</p>
                    </div>
                </div>
                <div className="col-md-6 col-12">
                    <div className="p-lg-4 px-4 py-2">
                        {customer.address?.address_1 &&
                            <>
                                <label>{gettext("Address")}</label>
                                <p>
                                    {getAddress(customer.address)}
                                </p>
                            </>
                        }
                    </div>
                </div>
                <div className="col-1 align-self-stretch d-flex align-items-center justify-content-center ps-0 arrow-divider">
                    <SvgArrow />
                </div>
            </div>
        </div>
    </Link>
    )
}